
var controller = new ScrollMagic.Controller();
var sticky     = null;

jQuery(document).ready(function($) {

	var isTouch = Modernizr.touchevents;

	if( $('.number').length > 0 ){
		$('.number').each(function(i, element){
			var currentScreen = this;
			new ScrollMagic.Scene({
				triggerElement: currentScreen,
				reverse:false
			}).on("enter", function (event) {
				$("span").addClass('active');
			    $("span", $(this.triggerElement())).animateNumber({ number: $("span", $(this.triggerElement())).data('number') }, 1000 );
			})
			.triggerHook(0.90)
			.addTo(controller);
		});
	}

	var tween =  TweenMax.fromTo( $('.bg-panorama-montain'), 10, { y: "-70%" }, { y: "-100%" } );
	var scene = new ScrollMagic.Scene({
		triggerElement: $('.bg-panorama-montain'),
		triggerHook: 1,
		duration: "70%"
	})
	.setTween( tween )
	.addTo( controller );

	var tween =  TweenMax.fromTo( $('.bg-panorama-montain-tree'), 10, { y: "-70%" }, { y: "-100%" } );
	var scene = new ScrollMagic.Scene({
		triggerElement: $('.bg-panorama-montain-tree'),
		triggerHook: 1,
		duration: "100%"
	})
	.setTween( tween )
	.addTo( controller );

	$('.bg-panorama-montain-tree').css( 'margin-bottom', -$('.bg-panorama-montain-tree').height() );
	$('.bg-panorama-montain').css( 'margin-bottom', -$('.bg-panorama-montain').height() );

	$('.star').each(function(i, element){
		var scene = new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: "onEnter",
			duration: "100%"
		}).on("enter", function (event) {
			$("span").addClass('active');
		})
		.addTo( controller );
	});

	if( $('.slick-home-slider').length > 0 ){

		scene = new ScrollMagic.Scene({
			triggerElement: $('.slick-home-slider'),
			triggerHook: "onEnter",
			duration: "100%"
		}).on("enter", function (event) {
			$('.slick-current').addClass('slick-slide--active');
		})
		.addTo( controller );

	}

	/*
	##    ##    #######   ########    #######   ##     ##   ######    ##     ##  
	###   ##   ##     ##     ##      ##     ##  ##     ##  ##    ##   ##     ##  
	####  ##   ##     ##     ##      ##     ##  ##     ##  ##         ##     ##  
	## ## ##   ##     ##     ##      ##     ##  ##     ##  ##         #########  
	##  ####   ##     ##     ##      ##     ##  ##     ##  ##         ##     ##  
	##   ###   ##     ##     ##      ##     ##  ##     ##  ##    ##   ##     ##  
	##    ##    #######      ##       #######    #######    ######    ##     ##  
	*/

	if( !isTouch ){
		
		$('.thumb').each(function(i, element){
			var tween =  TweenMax.to( this, 10, { opacity : 1, y: "0" } );
			var scene = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: "onEnter",
				duration: "70%"
			})
			.setTween( tween )
			.addTo( controller );
		});

		scene = new ScrollMagic.Scene({

			triggerElement: $('#stick'),
			triggerHook : 0

		}).on("enter", function (event) {

			$('.nav-main').css('opacity',0);
			sticky = new Waypoint.Sticky({
				element: $('.container-header')
			});

		}).on("leave", function (event) {

			$('.header').removeClass('stuck-active');
			$('.nav-main').css('opacity',1);
			if( sticky ) sticky.destroy();

		})
		.addTo( controller );
	
	}

});